import { SVGProps } from 'react';

export const Check = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="13"
    height="10"
    viewBox="0 0 13 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.88675 9.38725L0 4.5005L1.864 2.6365L4.88675 5.65925L10.546 0L12.41 1.864L4.88675 9.38725Z"
      fill="currentColor"
    />
  </svg>
);
